import { render, staticRenderFns } from "./history.vue?vue&type=template&id=21d79b80&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&lang=less&"
import style1 from "./history.vue?vue&type=style&index=1&id=21d79b80&lang=scss&scoped=true&"
import style2 from "./history.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d79b80",
  null
  
)

export default component.exports